import { render, staticRenderFns } from "./UiCheckboxGroup.vue?vue&type=template&id=63c4a048"
import script from "./UiCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./UiCheckboxGroup.vue?vue&type=script&lang=js"
import style0 from "./UiCheckboxGroup.vue?vue&type=style&index=0&id=63c4a048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports